import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { GlobalModule } from '@app/core/global.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { InputSearchModule } from '@components/input-search/input-search.module';
import { FuiTooltipDirective } from '@fui/fui-components';
import { HighlightModule } from '../highlight/highlight.module';
import { HoverModule } from '../hover/hover.module';
import { TreeAddOptionsComponent } from './components/add-options/tree-add-options.component';
import { TreeCommonComponent } from './components/common/tree-common.component';
import { TreeDirective } from './tree.directive';

@NgModule({
    declarations: [TreeDirective, TreeCommonComponent, TreeAddOptionsComponent],
    exports: [TreeDirective, TreeCommonComponent, TreeAddOptionsComponent],
    imports: [
        GlobalModule,
        OverlayModule,
        HighlightModule,
        InputSearchModule,
        ButtonModule,
        HoverModule,
        FuiTooltipDirective,
    ],
})
export class TreeModule {}
